module.exports = __webpack_public_path__ + "static/img/aleksandar-karisik.d0aa29dd.jpg";